import classNames from "classnames";
import Swal from "sweetalert2";
import usePDFDownload from "../../../hooks/usePDFDownload";
import LoadingButton from "../../Loading/LoadingButton";

export default function PrintLabelButton({
  ids = undefined,
  numberParcels = undefined,
  className = "",
  title = "پرینت لیبل",
}) {
  const { mutate, isPending } = usePDFDownload({
    url: "/totalpost/v1/label",
    body: {
      ids,
      numberParcels,
    },
  });

  const onClick = () => {
    if (!ids?.length && !numberParcels?.length) {
      Swal.fire({
        icon: "error",
        text: "انتخاب حداقل یک سفارش الزامی است",
        confirmButtonColor: "red",
        confirmButtonText: "باشه",
      });
      return;
    }

    mutate();
  };

  if (isPending) {
    return <LoadingButton title="در حال دریافت" center className={className} />;
  }

  return (
    <button
      className={classNames("btn", className)}
      type="button"
      onClick={onClick}
    >
      {title}
    </button>
  );
}
